import { FormControl,Select,InputLabel,MenuItem } from "@mui/material";
function PeerGroupList(props){
    // Sort peer groups by peerName
    const sortedPeerGroups = [...props.peerGroups].sort((a, b) => 
        (a.peerName || '').localeCompare(b.peerName || '')
    );

    const handleChange = (e)=>{
        props.setSelectedPeerGroupId(e.target.value)
    };
    if(props.peerGroups!==undefined&&props.peerGroups!==null && props.peerGroups.length>0)
    {
    return (
        <>
        <FormControl className="formControl">
            <InputLabel id="demo-simple-select-label">Peer Group</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={props.selectedPeerGroupId}
                label="Peer Group"
                onChange={handleChange}
            >
                <MenuItem value={0}>Select Peer Group</MenuItem>
                {sortedPeerGroups.map((pg) => {
                    return <MenuItem key={pg.peerGroupId} value={pg.peerGroupId}>{pg.peerName}</MenuItem>
                })}
            </Select>
        </FormControl>
        </>
    )
    }else{
        return (<></>);
    }
}

export default PeerGroupList;